module.exports = __webpack_public_path__ + "img/versicherungsapp-fuer-unternehmen-vapp.429e6205.gif";